import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-12">
                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                <div className="col-md-12">
                    <div className="about-desc">
                    <span className="heading-meta">About Us</span>
                    <h2 className="colorlib-heading">Who Am I?</h2>
                    <p>1. Have overseas work experience, including nearly 2 years of exchange research and development in Dubai while working at Blockchain China</p>
                    <p>2. Have rich front-end work experience, with 7+ years of experience in React and Vue, and 3+ years of project experience in Uniapp</p>
                    <p>3. Proficient in ecological technologies for packaging and building front-end projects: webpack, nginx, Jenkins, Docker, etc.</p>
                    <p>4. Remotely assist foreign technicians to solve technical problems such as Angular, React, and Vue in their spare time</p>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
        <section className="colorlib-about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">What I do?</span>
                <h2 className="colorlib-heading">Here are some of my expertise</h2>
            </div>
            </div>
            <div className="row" style={{marginTop: "2em"}}>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                <span className="icon">
                    <i className="icon-bulb" />
                </span>
                <div className="desc">
                    <h3>Front-end development</h3>
                    <p>I have extensive experience in front-end work and am proficient in technology stacks such as React, Vue, JavaScript, HTML, and CSS.</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Data Structures & Algorithms</h3>
                    <p>Coming from an engineering design background, I have a good grasp of basic concepts of data structures and project building</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Dev Ops</h3>
                    <p>Proficient in ecological technologies for packaging and building front-end projects: webpack, nginx, Jenkins, Docker, etc.</p>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
      </div>
    )
  }
}
